import React, { Component } from 'react'
import { Link } from 'react-router'
import { get } from 'lodash'

import cn from 'classnames'
import s from './BlogAuthor.scss'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'

export default class BlogAuthor extends Component {
  render() {
    const { vertical, article } = this.props

    const author = get(article, 'fields.author.fields')
    if (author) {
      return (
        <div className={cn(s.author, sLay['layout-column'], sLay['hide-xs'], sLay['hide-sm'])}>
          <Link to={{ pathname: '/blog', query: { author: author.name } }}>
            <img
              src={get(author, 'picture.fields.file.url')}
              alt="userimage"
              style={vertical ? { marginBottom: '15px' } : {}}
            />
          </Link>

          <div className={cn(sLay.flex, sLay['layout-column'])}>
            <div className={cn(sLay.flex, sLay['layout-row'])}>
              <div className={sText.descrip2}>{author.name}</div>
              <div className={sLay.flex} />
            </div>
            <p>{author.blurb}</p>
            <Link className={s.more} to={{ pathname: '/blog', query: { author: author.name } }}>
              More
            </Link>
          </div>
        </div>
      )
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Blog/BlogAuthor/BlogAuthor.jsx